import {Component, Input} from '@angular/core';


@Component({
    selector: 'app-generic-service-complete',
    templateUrl: './generic-service-complete.component.html',
    styleUrls: ['./generic-service-complete.component.scss'],
    standalone: true,
    imports: []
})
export class GenericServiceCompleteComponent {
  @Input() successText: string;
  @Input() errorText: string;
  @Input() showSuccess: boolean;
  @Input() showError: boolean;
  @Input() errorMessages: string[];
  constructor() { }

}

/****
 * Usage:
 *
 * This component is a generic way to show success/error of service calls to the user
 *
 * <app-generic-service-complete
 * [showError]="model.showError"
 * [showSuccess]="model.showSuccess"
 * [successText]="'Update complete'"
 * [errorText]="'Error on update'"
 * [errorMessages]="model.errorMessages"
 * ></app-generic-service-complete>
 *
 * showSuccess/showError can be reset with something like setTimeout in the parent component where appropriate
 */
